export default __webpack_public_path__ + "static/media/mathias_s.747aabf3.jpg";